import React, { useEffect, useState } from "react";
import Layout from "../tools/layout";
import "../styles/blog.css";
import Other from "../components/other/other";
import Articles from "../components/blog/articles";

function Blog() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Blog | Ion Niculica";

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Layout>
      <div className="blog">
        <div className="blog-container article-wrapper">
          {loading && (
            <div className="article-loader-overlay">
              <div className="spinner"></div>
            </div>
          )}

          <div style={{ visibility: loading ? "hidden" : "visible" }}>
            <Articles />
          </div>
        </div>

        <Other />
      </div>
    </Layout>
  );
}

export default Blog;